import request from '@/utils/requset'

// 实验详情
export function expInfo(id) {
  return request({
    url: `h5/course/${id}`,
    method: 'post'
  })
}
//问题提问
export function subQuestion(data) {
  return request({
    url: `h5/course/exchange`,
    method: 'post',
    data: data
  })
}
//问题列表
export function questionList(data) {
  return request({
    url: `h5/exchange/public_lists`,
    method: 'get',
    params: data
  })
}
// 评论列表
export function expComment(data) {
  return request({
    url: `h5/course/commentList`,
    method: 'post',
    data: data
  })
}

// 实验评论
export function expCommentSubmit(data) {
  return request({
    url: `h5/course/comment`,
    method: 'post',
    data: data
  })
}

// 实验提问、交流
export function expChange(data) {
  return request({
    url: `h5/course/exchange`,
    method: 'post',
    data: data
  })
}